import React, {  useState } from "react";
import Swal from "sweetalert2";
import { doLogin } from "../../api/auth.ts";
import { useAuthStore } from "../../store/auth.store.ts";
import { ButtonComponent, AnchorComponent } from "../../components/elements";
import IconFieldComponent from "../../components/fields/IconFieldComponent";
import forge from 'node-forge';
export default function LoginPage() {

  const setToken = useAuthStore(state => state.setToken);
  const setUsuario = useAuthStore(state => state.setUsuario);

  
  const publicKeyPem = `-----BEGIN PUBLIC KEY-----
  MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA5cHZ4zreWh983kmDp1Mk
  /VFpQ+WdG8dFaYBhkpNkRLETRqrBCi6fq/bLxkbn4M8VOtLPNVw53oU6RS8sh2AH
  bJCiwNj1xgv/GsqDDHpP72CCZwEEYR9GiRn9ua41RyG6YK0dWyeN9WXK+C24oFeD
  ARB9D5fe/kFgyhZ+4dWctVMthN6XlYhHtPRyMqb6Z8StWJMGDTtFIJ5mApLB0UYN
  r63Mjkc1Ua357irP+Py6Zw1+hc3s6nEf6Ku/rQM5DjxMNG1ucFVFsSqvlSEcN9AU
  j4jN5om1GpZKpXIxkP39BvDzsVMEXGHMrtFmK0xCcJ+8Lo5K3MECWmB3LuSzqqmI
  6wIDAQAB
  -----END PUBLIC KEY-----
  `;



  const [formData, setFormData] = useState({
    email: "",
    password: ""
  });

  const handleInputChange = (
    e
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const publicKeyObj = forge.pki.publicKeyFromPem(publicKeyPem);
    const encrypted = publicKeyObj.encrypt(formData.password, "RSA-OAEP");

    const encryptedPassword = forge.util.encode64(encrypted);
   
    doLogin(formData.email, encryptedPassword).then(res => {
      if (res.error === true) {
        Swal.fire({
          text: "El email o password incorrectos.",
          icon: "warning",
          confirmButtonText: "Ok"
        });
        return;
      }

      if (res.usuario && res.token) {
        window.localStorage.setItem("token", res.token);
        window.localStorage.setItem(
          "token-init-date",
          new Date().getTime().toString()
        );

        setToken(res.token);

        setUsuario({
          id: res.usuario.id,
          rut: res.usuario.rut,
          dv: res.usuario.dv,
          email: res.usuario.email,
          nombre: res.usuario.nombre,
          apellido: res.usuario.apellido,
          initial_password_modified: res.usuario.initial_password_modified,
          activo: res.usuario.activo,
          roles: res.usuario.roles
        });
      }
    });
  };

  
  return (
    <div className="mc-auth" translate="no">
      {/* Header con logo */}
      <div className="mc-auth-header">
        <img src="images/logo.png" alt="CRISTOUR" className="mc-auth-logo-header" />
        <div className="mc-auth-help">
          <div className="mc-auth-feature-icon">
              <img src="images/support.png" alt="Soporte" />
            </div>
          <span>¿Necesitas ayuda?</span>
          <a href="mailto:contacto@cristourviajes.cl">contacto@cristourviajes.cl</a>
        </div>
      </div>

      {/* Contenedor principal con dos columnas */}
      <div className="mc-auth-container" >
        {/* Contenedor único - Bienvenida y Formulario */}
        <div className="mc-auth-welcome">
          <div className="mc-auth-welcome-content">
            <h1 className="mc-auth-welcome-title">Bienvenido a tu<br />portal de clientes</h1>
            <p className="mc-auth-welcome-subtitle">Accede a toda la información de tu gira en un solo lugar.</p>
          </div>

          {/* Formulario de login */}
          <div className="mc-auth-form-wrapper">
            <h2 className="mc-auth-form-title">Iniciar Sesión</h2>
            <p className="mc-auth-form-subtitle">Ingresa tus credenciales para continuar</p>

            <form className="mc-auth-form" onSubmit={handleSubmit} translate="no">
              <div className="mc-auth-input-group">
                <IconFieldComponent
                  icon="person"
                  type="text"
                  name="email"
                  required
                  classes="w-100"
                  placeholder="correo@ejemplo.cl"
                  onChange={handleInputChange}
                />
              </div>

              <div className="mc-auth-input-group">
                <IconFieldComponent
                  icon="lock"
                  type="password"
                  name="password"
                  classes="w-100"
                  required
                  placeholder="Ingresa tu contraseña"
                  onChange={handleInputChange}
                  passwordVisible={true}
                />
              </div>

              <ButtonComponent className="mc-auth-btn-submit" type="submit">
                INGRESAR
              </ButtonComponent>

              <AnchorComponent className="mc-auth-forgot-link" to="/recuperar-password">
                ¿Olvidaste tu contraseña?
              </AnchorComponent>
            </form>
          </div>

          {/* Imagen de avión */}
         
        </div>
      </div>

      {/* Footer con características */}
      <footer className="mc-auth-footer">
        <div className="mc-auth-footer-content">
          <div className="mc-auth-feature-card">
            <div className="mc-auth-feature-icon">
              <img src="/images/trips.png" alt="Mis Giras" onError={(e) => e.target.style.display = 'none'} />
            </div>
            <h3 className="mc-auth-feature-title">Mis Giras</h3>
            <p className="mc-auth-feature-desc">Revisa itinerarios, fechas, servicios y documentos de tus giras.</p>
          </div>

          <div className="mc-auth-feature-card">
            <div className="mc-auth-feature-icon">
              <img src="/images/passengers.png" alt="Pasajeros" onError={(e) => e.target.style.display = 'none'} />
            </div>
            <h3 className="mc-auth-feature-title">Pasajeros</h3>
            <p className="mc-auth-feature-desc">Consulta la lista de pasajeros, datos y documentación.</p>
          </div>

          <div className="mc-auth-feature-card">
            <div className="mc-auth-feature-icon">
              <img src="/images/payments.png" alt="Pagos" onError={(e) => e.target.style.display = 'none'} />
            </div>
            <h3 className="mc-auth-feature-title">Pagos</h3>
            <p className="mc-auth-feature-desc">Visualiza montos y fechas de pagos de tu gira.</p>
          </div>

          <div className="mc-auth-feature-card">
            <div className="mc-auth-feature-icon">
              <img src="/images/documents.png" alt="Documentos" onError={(e) => e.target.style.display = 'none'} />
            </div>
            <h3 className="mc-auth-feature-title">Documentos</h3>
            <p className="mc-auth-feature-desc">Descarga contratos, coberturas y documentos importantes.</p>
          </div>

          
        </div>
      </footer>
    </div>
  );
}
